<template><md-dialog :md-active.sync="visiable" :md-click-outside-to-close="false">
  <md-dialog-title>{{ $t("Address") }}</md-dialog-title>

  <md-dialog-content>
    <div class="component-flight-review-address-pop">
      <div class="md-layout-item md-small-size-100 md-size-100">
        <md-radio
          v-model="reviewAddress.address_customized"
          :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO"
          >{{ $t("Address") }}</md-radio
        >
        <md-radio
          v-model="reviewAddress.address_customized"
          :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED"
          >{{ $t("GPS Coordinates") }}</md-radio
        >
        <md-radio
          v-if="pilot_network !== PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER"
          v-model="reviewAddress.address_customized"
          :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB"
          >MAAC Club</md-radio
        >
      </div>

      <div
        v-show="isClub"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-dropdown-input
          :options="clubs"
          v-model="reviewAddress.club_id"
          :label="$t('MAAC Club')"
          name="club"
          :validation-rules="{
            required: isClub ? true : false
          }"
          :valueTransformation="item => item._id.$oid"
          :displayTransformation="item => item.club_name"
          @input="onClubeChange"
        />
      </div>

      <template v-if="isClub && reviewAddress.club_id">
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-text-input
            :disabled="true"
            :label="$t('City')"
            name="city"
            v-model="reviewClubAddress.review_city"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-autocomplete-input
            :disabled="true"
            :label="$t('Province')"
            name="province"
            v-model="reviewClubAddress.review_province"
            :options="provinces"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-text-input
            :disabled="true"
            :label="$t('Postal Code')"
            name="postalcode"
            v-model="reviewClubAddress.review_postalcode"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-text-input
            :disabled="true"
            :label="$t('latitude')"
            name="latitude"
            v-model="reviewClubAddress.latitude"
            @blur="longitudeOrlatitudeBlur"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-text-input
            :disabled="true"
            :label="$t('longitude')"
            name="longitude"
            v-model="reviewClubAddress.longitude"
            @blur="longitudeOrlatitudeBlur"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-autocomplete-input
            :disabled="true"
            :label="$t('timezone')"
            name="timezone"
            v-model="reviewClubAddress.review_timezone"
            :options="CanadaTimezones"
          />
        </div>
        <div class="md-layout-item md-small-size-100 md-size-100">
          <validated-text-input
            :disabled="true"
            :label="$t('Flight Review Address description')"
            name="street description"
            v-model="reviewClubAddress.review_street_desc"
          />
        </div>
      </template>

      <div
        v-show="isAuto"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :label="$t('Flight Review Address')"
          name="street"
          v-model="reviewAddress.review_street"
          :validation-rules="{
            required: isAuto ? true : false,
            regex: /^.{6,}$/
          }"
        />
      </div>
      <div
        v-show="isAuto || isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :disabled="isClub"
          :label="$t('City')"
          name="city"
          v-model="reviewAddress.review_city"
          :validation-rules="{
            required: !!(isAuto || isCustomized),
            regex: /^.{3,}$/
          }"
        />
      </div>
      <div
        v-show="isAuto || isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-autocomplete-input
          :disabled="isClub"
          :label="$t('Province')"
          name="province"
          v-model="reviewAddress.review_province"
          :options="provinces"
          :validation-rules="{
            required: !!(isAuto || isCustomized),
            regex: /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/
          }"
        />
      </div>
      <div
        v-show="isAuto || isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :disabled="isClub"
          :label="$t('Postal Code')"
          name="postalcode"
          v-model="reviewAddress.review_postalcode"
          :validation-rules="{
            required: !!(isAuto || isCustomized),
            regex: /^([A-Z][0-9][A-Z] [0-9][A-Z][0-9])$/
          }"
          mask="A#A #A#"
        />
      </div>
      <div
        v-show="isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :disabled="isClub"
          :label="$t('latitude')"
          name="latitude"
          v-model.trim="reviewAddress.latitude"
          :validation-rules="{
            required: isCustomized ? true : false
          }"
          @blur="longitudeOrlatitudeBlur"
        />
      </div>
      <div
        v-show="isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :disabled="isClub"
          :label="$t('longitude')"
          name="longitude"
          v-model.trim="reviewAddress.longitude"
          :validation-rules="{
            required: isCustomized ? true : false
          }"
          @blur="longitudeOrlatitudeBlur"
        />
      </div>
      <div
        :style="`visibility: ${isCustomized ? 'visible' : 'hidden'}`"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-autocomplete-input
          :disabled="isClub"
          :label="$t('timezone')"
          name="timezone"
          v-model="reviewAddress.review_timezone"
          :options="CanadaTimezones"
          :validation-rules="{
            required: isCustomized ? true : false
          }"
        />
      </div>
      <div
        v-show="isCustomized"
        class="md-layout-item md-small-size-100 md-size-100"
      >
        <validated-text-input
          :disabled="isClub"
          :label="$t('Flight Review Address description')"
          name="street description"
          v-model="reviewAddress.review_street_desc"
          :validation-rules="{
            required: isCustomized ? true : false,
            regex: /^.{2,49}$/
          }"
        />
      </div>
    </div>
  </md-dialog-content>
  <md-dialog-actions>
    <md-button @click="onclose && onclose()">Close</md-button>
    <md-button class="md-primary" @click="save" :disabled="btnLoading">Save</md-button>
  </md-dialog-actions>
</md-dialog></template>

<script>
import {
  provinces,
  REVIEWER_PRICE_MIN,
  REVIEWER_PRICE_MAX,
  CanadaTimezones,
  FLIGHT_REVIEW_ADDRESS,
  PILOT_NETWORK,
  FLIGHT_REVIEW_PACKAGE_TYPE
} from "@/const.js";
import { mapFields } from "vuex-map-fields";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInputBrief.vue";
import ValidatedAutocompleteInput from "@/components/Inputs/ValidatedAutocompleteInput.vue";
import ValidatedDropdownInput from "@/components/Inputs/ValidatedDropdownInputBrief.vue";
import {
  searchTimeZone,
  findClubs,
  updateReviewAddress
} from "@/services/flightReview.service.js";

export default {
  components: {
    ValidatedTextInput,
    ValidatedAutocompleteInput,
    ValidatedDropdownInput
  },
  props: {
    visiable: Boolean,
    onclose: Function,
    onsave: Function,
    reviewAddressDefault: Object
  },
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapFields("auth", ["pilot_network"]),
    isAuto() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO
      );
    },
    isCustomized() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED
      );
    },
    isClub() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB
      );
    }
  },
  data() {
    return {
      btnLoading: false,
      PILOT_NETWORK,
      FLIGHT_REVIEW_ADDRESS,
      provinces,
      CanadaTimezones,
      reviewAddress: {
        // flight review address
        review_street: "",
        review_city: "",
        review_province: "",
        review_postalcode: "",
        address_customized: FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO,
        review_street_desc: "",
        longitude: "",
        latitude: "",
        review_timezone: "",
        flight_schools: [],
        club_id: "",
        id: ""
      },
      reviewClubAddress: {
        review_city: "",
        review_province: "",
        review_postalcode: "",
        review_street_desc: "",
        longitude: "",
        latitude: "",
        review_timezone: "",
        id: ""
      },
      clubs: [],

    };
  },
  mounted() {
    this.loadClubs();
    this.initReviewerAddress(this.reviewAddressDefault || {})
  },
  methods: {
    save() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          if (
            this.isCustomized &&
            CanadaTimezones.indexOf(this.reviewAddress.review_timezone) ===
            -1
          ) {
            this.$notify({
              message: this.$t("Please select the correct time zone."),
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "warning",
              timeout: 3000
            });
            return;
          }

          this.btnLoading = true;
          const {
            review_street,
            review_city,
            review_province,
            review_postalcode,
            flight_schools,
            review_street_desc,
            address_customized,
            longitude,
            latitude,
            review_timezone,
            club_id,
            id
          } = this.reviewAddress;
          
          
          let postDate = {
            review_street: address_customized === FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED ? '' : review_street,
            review_street_desc: address_customized === FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO ? '' : review_street_desc,
            review_city,
            review_province,
            review_postalcode,
            flight_schools,
            address_customized,
            longitude,
            latitude,
            review_timezone,
            id
          }

          if (address_customized === FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB) {
            postDate = {
              address_customized,
              club_id,
              id
            }
          }

          updateReviewAddress(postDate)
            .then(() => {
              this.$notify({
                message: this.$t(
                  "Update flight review address successful"
                ),
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
                timeout: 3000
              });
              this.onsave && this.onsave();
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    longitudeOrlatitudeBlur() {
      if (this.latitude && this.longitude) {
        searchTimeZone(this.latitude, this.longitude).then(res => {
          this.reviewAddress.review_timezone = res;
        });
      }
    },
    onClubeChange(val) {
      const selectedObj = this.clubs.find(item => item._id.$oid === val);
      if (!selectedObj) return;
      const {
        latitude,
        longitude,
        review_city,
        review_postalcode,
        review_province,
        review_street_desc,
        _id,
        review_timezone
      } = selectedObj;
      this.reviewClubAddress = {
        review_city,
        review_province,
        review_postalcode,
        review_street_desc,
        longitude,
        latitude,
        review_timezone
      };
      this.reviewAddress.club_id = _id.$oid;
    },
    initReviewerAddress(addressobj) {
      Object.keys(this.reviewAddress).forEach(key => {
        this.reviewAddress[key] = addressobj[key] || "";
      });
      this.reviewAddress = { ...this.reviewAddress, id: addressobj._id.$oid };
      // club address
      if (addressobj.address_customized == FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB) {
        Object.keys(this.reviewClubAddress).forEach(key => {
          this.reviewClubAddress[key] = addressobj[key] || "";
        });
        this.reviewClubAddress = { ...this.reviewClubAddress, id: addressobj._id.$oid };
      }
    },
    async loadClubs() {
      this.clubs = await findClubs();
    },
  }
};
</script>

<style lang="scss">
.component-flight-review-address-pop {
  padding: 20px 16px;
  height: 500px;
}
</style>
